<template>
	<div class="control">
		<div class="form-group input-group alphabet-control">
			<button class="btn-alpha notranslate"
					v-bind:class="(char == query) ? 'selected' : ''"
					v-bind:disabled="isDisabled(char)"
					v-on:click="selectCharacter(char)"
					v-for="char in alpha" v-bind:key="char">
				{{ char }}
			</button>
			<button class="btn-clear"
					v-if="query && query != ''"
					v-on:click="clearSearch()">
				Clear
			</button>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['control', 'parent'],
		data: function () {
			return {
				alpha: [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"],
				query: this.control.defaultValue,
			}
		},
		inject: {
			$validator: '$validator'
		},
		mounted: function () {
			let initialData = this.$store.state.listing.specification[this.parent.specification];
			if (initialData !== '') {
				this.query = initialData;
			}
			// clear current input on reset
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/resetSpecification') {
					this.query = this.parent.defaultValue;
				}
			});

			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
				}
			});
		},
		methods: {
			...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			isDisabled(char) {
				var existing = this.control.find(x => x.Name == char);
				if (existing != null) {
					return false;
				}
				return true;
			},
			selectCharacter(char) {
				if (this.query == char) {
					this.query = "";
				} else {
					this.query = char;
				}
				this.updateFilters();
			},
			clearSearch() {
				this.query = "";
				this.updateFilters();
			},
			updateFilters() {
				// if hitting api on each checkmark change
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.updateSpecification({ key: this.parent.specification, value: this.query });
					}
				});
			},
		}
	}
</script>